import "jquery.formelements";

function initCoworkerContactSearch() {
    const input = document.getElementById("coworkers-contact-search");
    const grid = document.querySelector(".contact-coworkers__grid");
    const emptyMsg = document.getElementById("contact-coworkers-search-empty");
    if (!input || !grid) {
        return;
    }

    const cards = grid.querySelectorAll(".contact-coworkers__card");
    if (cards.length === 0) {
        return;
    }

    const countEl = document.querySelector(
        ".contact-coworkers__header__count",
    );

    const setVisibleCountLabel = (visible) => {
        if (!countEl) {
            return;
        }
        countEl.textContent =
            visible === 1 ? "1 PERSON" : `${visible} PERSONER`;
    };

    const applyFilter = () => {
        const q = input.value.trim().toLowerCase();
        let visible = 0;
        cards.forEach((card) => {
            const haystack = (
                card.getAttribute("data-coworker-search") || ""
            ).toLowerCase();
            const match = !q || haystack.includes(q);
            card.classList.toggle("contact-coworkers__card--filtered-out", !match);
            if (match) {
                visible += 1;
            }
        });
        setVisibleCountLabel(visible);
        if (emptyMsg) {
            emptyMsg.hidden = visible > 0 || !q;
        }
    };

    input.addEventListener("input", applyFilter);
    input.addEventListener("search", applyFilter);
    applyFilter();
}

$(function () {
    $(".formelement-select-purple").formelements({
        classlist: "formelements_item select select select--purple",
    });

    $(".formelement-select-blue").formelements({
        classlist: "formelements_item select select select--blue",
    });

    $(".formelement-select-contact").formelements({
        classlist: "formelements_item select select select--contact-location",
    });

    $(".formelement-select-grey").formelements({
        classlist: "formelements_item select select select--grey",
    });

    $("#offices-contact").change(function () {
        var val = $(this).val();
        window.location.href = val;
    });

    $("#submenu").change(function () {
        var val = $(this).val();
        window.location.href = val;
    });

    initCoworkerContactSearch();
});
